document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".section-videos-wrapper-video").forEach((t) => {
    const e = t.querySelector("video"),
      o = t.querySelector(".play-button");
    e.controls = !1;
    const n = () => {
      e
        .play()
        .then(() => {
          (e.controls = !0),
            (o.style.opacity = "0"),
            (o.style.visibility = "hidden");
        })
        .catch((t) => {
          console.error("Error playing video:", t);
        }),
        o.removeEventListener("click", n),
        e.removeEventListener("click", n);
    };
    o.addEventListener("click", n), e.addEventListener("click", n);
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const t = document.querySelector(".section-videos-wrapper");
  t &&
    t.addEventListener("wheel", (e) => {
      window.innerWidth > 768 &&
        (e.preventDefault(), (t.scrollLeft += e.deltaY));
    });
});
